import React, { useEffect } from "react";
import InformationDataValidationSupport from "./informationDataValidationSupport";
import store from "../../src/stateManagement/store";
import { cardData } from "../components/dataValidationSupportRegistry/dataValidationSupportRegistry";
import { useNavigate } from "react-router-dom";

const InformationDataValidation = () => {
  const entity = store?.getState()?.mdmReducer?.id;
  const filteredEntityData = cardData?.filter((n) => n.cardName === entity);
  const navigate = useNavigate();

  useEffect(() => {
    if (!entity) {
        navigate("/dashboard/mdm");
      return;
    }});

  return (
    <>
      <div>
        {filteredEntityData.map((e) => {
          return (
            <InformationDataValidationSupport
              description={e.description}
              cardName={e.cardName}
              api={e.api}
              filters={e.filters}
              filtersCheck={e.filtersCheck}
            />
          );
        })}
      </div>
    </>
  );
};

export default InformationDataValidation;
